import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "disabled", "mode", "size", "theme", "onMouseEnter", "onMouseLeave", "onClick", "error"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@rescui/menu';
import cn from 'classnames';
import CheckboxControl from './parts/checkbox-control.js';
import styles from './parts/checkbox.p.module.css.js';
var Checkbox = /*#__PURE__*/React.forwardRef(function Checkbox(_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'classic' : _ref$mode,
      size = _ref.size,
      theme = _ref.theme,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      onClick = _ref.onClick,
      error = _ref.error,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, {
    tag: 'label',
    mode: 'clear',
    size: size,
    theme: theme,
    disabled: disabled,
    className: className,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    tabIndex: null,
    icon: /*#__PURE__*/React.createElement(CheckboxControl, _objectSpread({
      ref: ref,
      disabled: disabled,
      size: size,
      mode: mode,
      theme: theme,
      isError: Boolean(error),
      notUseLabelTag: true
    }, restProps))
  }, children), error && typeof error !== 'boolean' && /*#__PURE__*/React.createElement("div", {
    className: cn(styles.errorMessage, styles.single),
    "data-test": "checkbox-error-message"
  }, error));
});
Checkbox.propTypes = {
  checked: PropTypes.bool,
  children: PropTypes.node,
  defaultChecked: PropTypes.bool,
  name: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  indeterminate: PropTypes.bool,
  mode: PropTypes.oneOf(['classic', 'rock']),
  size: PropTypes.oneOf(['s', 'm', 'l'])
};
export { Checkbox, Checkbox as default };
